/**
 * Вспомогательные функции.
 */

import {HTTP_MODE} from "./consts.js";

/**
 * Вернет протокол, согласно переданной опции требуемого режима.
 * Все режимы и порядок их использования см. в {@link HTTP_MODE}.
 *
 * @deprecated
 * @param {String} httpMode
 * @param {Boolean} forApi
 * @return {String}
 */
export function getProtocolByMode(httpMode, forApi = true) {
  if (forApi) {
    return httpMode === HTTP_MODE.http ? "http" : "https";
  }
  return httpMode === HTTP_MODE.https ? "https" : "http";
}

/**
 * Преобразует заданный URL в правильную форму:
 * - слеш на конце
 * - имеется домен и протокол
 *
 * Опционально можно преобразовать протокол.
 *
 * @deprecated
 * @param {String} oldUrl
 * @param {Boolean} toSecure
 * @return {String}
 */
export function representUrl(oldUrl, toSecure = false) {
  let newBaseUrl = oldUrl;
  // Фикс для слеша в конеце.
  newBaseUrl = newBaseUrl.endsWith("/") ? newBaseUrl : `${newBaseUrl}/`;
  // Фикс для текущего протокола/домена
  if (!newBaseUrl.startsWith("http")) {
    newBaseUrl = newBaseUrl.startsWith("/") ? newBaseUrl : `/${newBaseUrl}`;
    newBaseUrl = `${window.location.origin}${newBaseUrl}`;
  }
  // Опциональное приведение к https.
  if (toSecure) {
    newBaseUrl = newBaseUrl.replace(/^http:\/\/(.*)/, "https://$1");
  } else {
    newBaseUrl = newBaseUrl.replace(/^https:\/\/(.*)/, "http://$1");
  }
  return newBaseUrl;
}

/**
 * Включит в браузере полноэкранный режим для указанного элемента.
 * Не забудь про потерю/передачу контекста this.
 *
 * @param {Element} el Элемент для включения полноэкранного режима из его содержимого.
 * @return {Promise}
 */
export function requestFullscreenByElement(el) {
  return (el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullscreen || (() => Promise.resolve())).call(el);
}

/**
 * Выключит полноэкранный режим.
 * Не забудь про потерю/передачу контекста this.
 *
 * @return {Promise}
 */
export function exitFullscreen() {
  if (document.fullscreenElement === null) {
    return Promise.resolve();
  }
  return (document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || (() => Promise.resolve())).call(document);
}

/**
 * Скачивание текста CSV в виде файла.
 *
 * @param {String} filename
 * @param {String} csvText
 */
export function downloadCSV(filename, csvText) {
  const blob = new Blob([`\uFEFF${csvText}`], {type: "text/csv;charset=utf-8;"});
  downloadBase64Content(filename, URL.createObjectURL(blob));
}

/**
 * Скачивание Base64 контента в виде файла.
 *
 * @param {String} filename
 * @param {String} content
 */
export function downloadBase64Content(filename, content) {
  const downloadLink = document.createElement("a");
  if (downloadLink.download !== undefined) {
    downloadLink.setAttribute("href", content);
    downloadLink.setAttribute("download", filename);
    downloadLink.style.visibility = "hidden";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
}